import * as types from "./types";

const mutations = {
    [types.LOADING_CAMPAIGN](state, payload) {
        state.loading = payload;
    },
    [types.GET_CAMPAIGN](state, payload) {
        state.marketingcampaign = payload;
    },
    [types.POST_CAMPAIGN_ID](state, payload) {
        state.marketingcampaign.push(payload);
    },
    [types.GET_CAMPAIGN_ID](state, payload) {
        state.marketingcampaignid = payload;
    },
    [types.UPDATE_CAMPAIGN](state, payload) {
        const index = state.marketingcampaign.findIndex((item) => item.id === payload.id);
        state.marketingcampaign.splice(index, 1, payload);
    },
    [types.DELETE_CAMPAIGN](state, payload) {
        const index = state.marketingcampaign.findIndex((item) => item.id === payload);
        state.marketingcampaign.splice(index, 1);
    }
};

export default mutations;